export default __webpack_public_path__ + "static/media/a_3.21271b5a.jpg";